<page-headline
    [linkTitle]="'Performance Insights'"
    [module]="'performance'"
    [moduleIcon]="'fa-heartbeat'"
    [moduleLink]="'performance/insights'"
    [pageTitle]="pageTitle"
>
</page-headline>
<main-filters (filtersOutput)="applyNewFilters($event)"></main-filters>
<div>
    <div class="displayopt-actionpanel-layout">
        <div class="ddl-area">
            <div class="kpi-profile-ddl">
                <angular2-multiselect
                    [data]="kpiProfile"
                    *ngIf="parameters.roleName === 'Employee'"
                    [(ngModel)]="selectedKPIProfile"
                    [settings]="kpiProfileSettings"
                    (onSelect)="onSelectionChangeProfile($event)"
                    (onDeSelect)="onDeSelectProfile($event)"
                >
                </angular2-multiselect>
            </div>
            <div>
                <angular2-multiselect
                    [data]="KPIs"
                    [(ngModel)]="selectedKPI"
                    [settings]="kpiListSettings"
                    (onSelect)="onSelectionChangeKpi($event.value)"
                    (onDeSelect)="onDeSelect($event)"
                >
                </angular2-multiselect>
            </div>
        </div>
        <display-options
            (displayOptionsOutput)="applyDisplayOptions($event)"
            [showCompareToDate]="false"
        >
        </display-options>
        <action-panel
            [showExportCsv]="false"
            [showSaveAsPdf]="true"
            [showPrint]="false"
            [title]="pageTitle"
        >
        </action-panel>
        <div class="lg-scrollbar toggle-switch-area">
            <span style="padding-right: 5px">{{ switchLabel }}</span>
            <p-toggleswitch
                *ngIf="records"
                [(ngModel)]="showNames"
                (onChange)="toggleDataLabels($event)"
                class="custom-switch"
            />
        </div>
    </div>
</div>
<div class="container performance-insights-kpi-container">
    <div id="bottom-ten-list" class="lg-scrollbar item-c scatter-plot-row">
        <div class="top-bottom-div">
            <div class="table-title">bottom 10</div>
            <div *ngIf="!noDataForCompany">
                <div *ngIf="loading">
                    <spin-loader [type]="'spinner'" class="table-spinner"></spin-loader>
                </div>
                <table
                    *ngIf="!loading && bottomEntities && bottomEntities.length > 0"
                    class="kpi-table"
                >
                    <tr>
                        <th class="name-col" colspan="2"></th>
                        <th class="table-header">Value</th>
                        <th class="table-header">&nbsp;%of Target</th>
                    </tr>
                    <ng-container *ngFor="let entity of bottomEntities; index as i">
                        <tr (mouseenter)="mouseEnter(entity)" (mouseleave)="mouseLeave(entity)">
                            <td class="number-rank-col">{{ bottom10Top + 1 + i }}.</td>
                            <td class="kpi-hierarchyName-column">
                                &nbsp;
                                <span
                                    class="hyperlink-text"
                                    (click)="topBottomNameClickHandler(entity)"
                                >
                                    {{
                                        entity.hierarchyAbrrName != null
                                            ? (entity.hierarchyAbrrName | slice : 0 : 14)
                                            : (entity.hierarchyName | slice : 0 : 14)
                                    }}
                                </span>
                            </td>
                            <td class="kpi-top-data">
                                {{ entity.kpiValueFormatted }}
                            </td>
                            <td class="kpi-top-data">
                                {{
                                    entity.pctofTarget > 99
                                        ? (entity.pctofTarget | number : '1.0-0')
                                        : (entity.pctofTarget | number : '1.1-1')
                                }}
                            </td>
                        </tr>
                    </ng-container>
                </table>
            </div>
            <div *ngIf="noDataForCompany && !loading">
                <no-data-screen [noDataType]="noDataType"></no-data-screen>
            </div>
        </div>
    </div>
    <div id="top-ten-list" class="lg-scrollbar scatter-plot-row">
        <div class="top-bottom-div">
            <div class="table-title">
                <span class="top-ten"> top 10 </span>
            </div>
            <div *ngIf="!noDataForCompany">
                <div *ngIf="loading">
                    <spin-loader [type]="'spinner'" class="table-spinner"></spin-loader>
                </div>
                <table *ngIf="!loading && records && records.length" class="kpi-table">
                    <tr *ngIf="!loading">
                        <th class="name-col" colspan="2"></th>
                        <th class="table-header">Value</th>
                        <th class="table-header">&nbsp;%of Target</th>
                    </tr>
                    <ng-container *ngFor="let entity of topEntities; index as i">
                        <tr (mouseenter)="mouseEnter(entity)" (mouseleave)="mouseLeave(entity)">
                            <td class="number-rank-col">{{ i + 1 }}.</td>
                            <td class="kpi-hierarchyName-column">
                                &nbsp;
                                <span
                                    class="hyperlink-text"
                                    (click)="topBottomNameClickHandler(entity)"
                                >
                                    {{
                                        entity.hierarchyAbrrName != null
                                            ? (entity.hierarchyAbrrName | slice : 0 : 14)
                                            : (entity.hierarchyName | slice : 0 : 14)
                                    }}
                                </span>
                            </td>
                            <td class="kpi-top-data">
                                {{ entity.kpiValueFormatted }}
                            </td>
                            <td class="kpi-top-data">
                                {{
                                    entity.pctofTarget > 99
                                        ? (entity.pctofTarget | number : '1.0-0')
                                        : (entity.pctofTarget | number : '1.1-1')
                                }}
                            </td>
                        </tr>
                    </ng-container>
                </table>
            </div>
            <div *ngIf="noDataForCompany && !loading">
                <no-data-screen [noDataType]="noDataType"></no-data-screen>
            </div>
        </div>
    </div>

    <div id="scatterplot-graph" class="scatter-plot-row">
        <large-card [largeCardInteriorOptions]="largeCardOptions"></large-card>
    </div>
    <div class="lg-scrollbar scatter-plot-row">
        <div class="legend-div">
            <div class="table-title">target</div>
            <div *ngIf="!noDataForPlotBands">
                <div *ngIf="plotBandsLoading">
                    <spin-loader [type]="'spinner'" class="table-spinner"></spin-loader>
                </div>
                <div *ngIf="!plotBandsLoading">
                    <div class="target-label">{{ targetUnits }} {{ title }}</div>
                    <div class="table-title target-tite">PERFORMANCE BANDS</div>
                    <table class="kpi-target-table">
                        <ng-container *ngFor="let band of bandsForLegend">
                            <tr
                                class="performance-band {{ band.className }} cursor-pointer"
                                (click)="zoomInOnBand(band)"
                            >
                                <td class="cell-padding">{{ band.name }}</td>
                                <td
                                    class="cell-padding text-align-right"
                                    [innerHTML]="band.description"
                                ></td>
                            </tr>
                        </ng-container>
                    </table>
                </div>
            </div>
            <div *ngIf="noDataForPlotBands && !plotBandsLoading">
                <no-data-screen [noDataType]="noDataTypePlotBands"></no-data-screen>
            </div>
        </div>
        <div style="text-align: right; padding-top: 16px">
            <button
                (click)="drawChart(); viewingBandNumber = 0"
                mat-stroked-button
                raised
                [ngClass]="{ hidden: !showingBandOnlyData }"
            >
                Full Graph
            </button>
        </div>
    </div>
</div>
